import { graphql } from "@opensea/graphql"

export const useTrackSwapEventFragment = graphql(`
  fragment useTrackSwapEvent on SwapQuote {
    slippageTolerance
    swapRoutes {
      ... on SwapRoute {
        fromAsset {
          ... on Currency {
            symbol
            contractAddress
            chainIdentifier
            chain {
              identifier
            }
            decimals
          }
        }
        toAsset {
          ... on Currency {
            symbol
            contractAddress
            chainIdentifier
            chain {
              identifier
            }
            decimals
          }
        }
        pricePerFromAsset {
          usd
        }
        pricePerToAsset {
          usd
        }
        fromQuantity
        toQuantity
        swapProvider
        costs {
          costType
          cost {
            usd
          }
        }
      }
    }
  }
`)
